import { Routes } from '@angular/router';
import { mapToCanActivate } from '@angular/router';
import { AuthGuard } from './identity/authGuard';

export const standaloneRoutes: Routes = [
  {
    path: 'designer/:fileName',
    loadComponent: () => import('./telerik-reporting/report-designer/designer/designer.component')
      .then(m => m.DesignerComponent),
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      roles: ['Telerik Report Edit'],
      standalone: true // Mark this route as standalone
    }
  },
  {
    path: 'viewer/:fileName',
    loadComponent: () => import('./telerik-reporting/report-viewer/viewer/viewer.component')
      .then(m => m.ViewerComponent),
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      roles: ['Telerik Report View'],
      standalone: true // Mark this route as standalone
    }
  }
]; 
